import InputForm from '../InputFormV2'
import useCatalogoOpcional from './useCatalogoOpcional'

interface PropiedadesSelectCatalogoV2 {
  endpoint: string
  nombre: string
  etiqueta: string
  marcador?: string
  valor: any
  error?: any
  requerido?: boolean
  deshabilitado?: boolean
  ayuda?: string
  mensajeSinCatalogo?: string
  onChange: (valor: string) => void
}

export default function SelectCatalogoV2({
  endpoint,
  nombre,
  etiqueta,
  marcador,
  valor,
  error,
  requerido,
  deshabilitado,
  ayuda,
  mensajeSinCatalogo,
  onChange,
}: PropiedadesSelectCatalogoV2) {
  const {opciones, cargando, disponible} = useCatalogoOpcional(endpoint)

  const sinCatalogo = !cargando && !disponible
  const textoSinCatalogo =
    mensajeSinCatalogo ??
    'Este catálogo todavía no está disponible. Puede emitir sin seleccionarlo y completarlo cuando aparezca.'

  return (
    <InputForm
      required={requerido}
      name={nombre}
      label={etiqueta}
      type='select'
      placeholder={cargando ? 'Cargando…' : marcador ?? etiqueta}
      value={`${valor ?? ''}`}
      options={opciones}
      keyNameText='codigo_nombre'
      keyNameValue='codigo'
      disabled={deshabilitado || cargando || sinCatalogo}
      error={error}
      helperText={sinCatalogo ? textoSinCatalogo : ayuda}
      onChange={(opcion: any) => onChange(`${opcion?.value ?? ''}`)}
    />
  )
}
